import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from '@/pages/home/components/Hero';
import QuickFacts from '@/pages/home/components/QuickFacts';
import StorySection from '@/pages/home/components/StorySection';
import CharactersSection from '@/pages/home/components/CharactersSection';
import ResourcesSection from '@/pages/home/components/ResourcesSection';
import PathSection from '@/pages/home/components/PathSection';
import HighlightsSection from '@/pages/home/components/HighlightsSection';
import TipsSection from '@/pages/home/components/TipsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import RelatedSection from '@/pages/home/components/RelatedSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <QuickFacts />
        <StorySection />
        <CharactersSection />
        <ResourcesSection />
        <PathSection />
        <HighlightsSection />
        <TipsSection />
        <FaqSection />
        <RelatedSection />
      </main>
      <SiteFooter />
    </div>
  );
}